var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ShowAi
    ? _c(
        "div",
        { staticClass: "warp" },
        [
          _c("yxt-divider", { attrs: { direction: "vertical" } }),
          _c(
            "div",
            {
              staticClass: "icon-warp",
              on: {
                click: function ($event) {
                  _vm.show = true
                },
              },
            },
            [
              _c("yxt-image", {
                staticClass: "ai-icon",
                class: _vm.isStu
                  ? "is-stu"
                  : _vm.tiny
                  ? "is-tiny"
                  : "is-manage",
                attrs: {
                  src: `${_vm.staticBaseUrl}ufd/407a24/assistent/pc/img/avatar.jpg`,
                },
              }),
              _c("yxt-svg", {
                staticClass: "ai-svg",
                attrs: {
                  "remote-url": `${_vm.staticBaseUrl}assets/cc14e4ef/0a2d2173/`,
                  width: "22px",
                  height: "15px",
                  "icon-class": "ai-3",
                },
              }),
            ],
            1
          ),
          _vm.isXxv2
            ? _c(
                "div",
                [
                  _c("yxtbiz-ai-robot", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show,
                        expression: "show",
                      },
                    ],
                    on: {
                      close: function ($event) {
                        _vm.show = false
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          !_vm.isXxv2
            ? _c(
                "div",
                [
                  _c("yxtbiz-ai-robot-demo", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show,
                        expression: "show",
                      },
                    ],
                    on: {
                      close: function ($event) {
                        _vm.show = false
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }